import { render, staticRenderFns } from "./DoorOpening.vue?vue&type=template&id=a2676004"
import script from "./DoorOpening.vue?vue&type=script&lang=js"
export * from "./DoorOpening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports